<template>
  <div>
    <div class="table-responsive">
      <table class="table table-striped table-bordered table-condensed" :bordered="true">
        <thead>
        <tr>
          <th v-for="tableHeader in tableHeaders" :key="tableHeader.value">
            {{ tableHeader.text }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(role, roleIndex) in roleWithPermissions" :key="role.clientType['@id']">
          <th>{{ role.clientType.title }}</th>
          <td v-for="(permission, index) in role.permissions" :key="permission[index]">
            <b-form-checkbox v-model="roleWithPermissions[roleIndex].permissions[index].value"></b-form-checkbox>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ApiService from '@/utils/ApiService'

export default {
  name: 'CreateRolesForTaskType',
  props: {
    initialRoleWithPermissions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      items: [],
      isLoading: true,
      roleWithPermissions: [],
      singlePermissions: [
        {
          value: false,
          text: 'create'
        },
        {
          value: false,
          text: 'read'
        },
        {
          value: false,
          text: 'read2'
        },
        {
          value: false,
          text: 'update'
        },
        {
          value: false,
          text: 'delete'
        },
        {
          value: false,
          text: 'accessFirm'
        },
        {
          value: false,
          text: 'accessGroup'
        },
        {
          value: false,
          text: 'accessSelf'
        },
        {
          value: false,
          text: 'accessAll'
        }
      ],
      tableHeaders: [
        {
          value: null,
          text: this.$t('views.excmtasktype.form.role')
        },
        {
          value: 'C',
          text: this.$t('views.excmtasktype.form.create')
        },
        {
          value: 'R1',
          text: this.$t('views.excmtasktype.form.read')
        },
        {
          value: 'R2',
          text: this.$t('views.excmtasktype.form.read2')
        },
        {
          value: 'U',
          text: this.$t('views.excmtasktype.form.update')
        },
        {
          value: 'D',
          text: this.$t('views.excmtasktype.form.delete')
        },
        {
          value: 'AF',
          text: this.$t('views.excmtasktype.form.accessFirm')
        },
        {
          value: 'AG',
          text: this.$t('views.excmtasktype.form.accessGroup')
        },
        {
          value: 'AS',
          text: this.$t('views.excmtasktype.form.accessSelf')
        },
        {
          value: 'AA',
          text: this.$t('views.excmtasktype.form.accessAll')
        }
      ]
    }
  },
  components: {
    // RoleForTaskType
  },
  watch: {
    'roleWithPermissions' () {
      this.$emit('roleWithPermissions', this.roleWithPermissions)
    }
  },
  created () {
    this.roleWithPermissions = [...this.initialRoleWithPermissions]
    this.getPermissionsArray()
  },
  methods: {
    async getPermissionsArray () {
      if (!(this.initialRoleWithPermissions.length > 0)) {
        const firstCaseTypePermissionsResponse = await new ApiService('e_x_c_m_case_types/1').getResults()
        if (firstCaseTypePermissionsResponse && firstCaseTypePermissionsResponse.allowedAccessRole) {
          let defaultAccessRoles = firstCaseTypePermissionsResponse.allowedAccessRole
          defaultAccessRoles.forEach((entry) => {
            let temp = this.createPermissionsObject(entry.clientType, this.singlePermissions)
            this.roleWithPermissions.push(temp)
          })
        } else {
          let params = {
            pagination: false,
            state: 1
          }
          const response = await new ApiService('client_types', params).getResults()
          this.items = response.items
          this.isLoading = false
          this.items.splice(this.items.findIndex(entry => {
            return entry.title === 'Super User'
          }), 1)
          this.items.forEach((entry) => {
            let temp = this.createPermissionsObject(entry, this.singlePermissions)
            this.roleWithPermissions.push(temp)
          })
        }
      }
    },
    createPermissionsObject (item, singlePermissions) {
      return {
        clientType: item,
        permissions: JSON.parse(JSON.stringify(singlePermissions))
      }
    }
  }
}
</script>

<style scoped>
.table td {
  text-align: center;
}
</style>
